import { useFeatureValue } from "@growthbook/growthbook-react";
import { isInternalUser } from "@utils/isInternalUser";
import { IS_ACTIVATION_ROLE } from "@utils/user_roles";
import { Label, Radio } from "flowbite-react";
import { FLAGS } from "../../../config/growthbook/flags.js";

const RoleListItem = ({
	role,
	selectedRoleName,
	handleRoleChange,
	errors,
	capitalizeFirstLetter,
	currentUserRole,
}) => {
	const id = `role-${role.id}`;
	const isActivationRole =
		currentUserRole.id === IS_ACTIVATION_ROLE || currentUserRole?.parent_id === IS_ACTIVATION_ROLE;

	const adistaDisplayEnabled = useFeatureValue(FLAGS.users.roles.adistaDisplayEnabled, false);

	if (isActivationRole && role.name === "admin") {
		return null;
	}

	return (
		<div className="flex flex-col p-4" key={role.name}>
			{/* Radio Button and Label */}
			<div className="flex items-center gap-2">
				<Radio
					id={id}
					name="roles"
					checked={selectedRoleName === role.name}
					onChange={() => handleRoleChange(role.id, role.name)}
					className={`focus:ring- h-4 w-4 rounded-full border-blue-gray bg-blue-gray text-blue-gray ring-offset-dark-blue focus:ring-dark-blue ${
						errors.selectedRoleId ? "border-red-500" : ""
					}`}
					required
				/>

				{/* Use GrowthBook feature flags to define user role name */}
				<Label className="!text-gray-300 text-normal" htmlFor={id}>
					{adistaDisplayEnabled
						? isInternalUser(currentUserRole)
							? role?.display_name
							: role?.description
						: capitalizeFirstLetter(role?.name)}
				</Label>
			</div>

			{/* Role Description */}

			{role?.resource_list?.length > 0 && (
				<div className="flex flex-col">
					<div className="group mt-1 ml-6 rounded-lg border border-blue-gray bg-navbar-bg p-2 text-gray-500 transition-all">
						<span className="text-xs">
							{role?.resource_list.map((res) => res?.display_name).join(", ")}
						</span>
					</div>
				</div>
			)}

			{/* Use GrowthBook feature flags to define user role description */}
			{role?.role_description && adistaDisplayEnabled && (
				<div className="flex flex-col">
					<div className="group mt-1 ml-6 rounded-lg border border-blue-gray bg-navbar-bg p-2 text-gray-500 transition-all">
						<div className="flex items-start justify-between">
							<div className="" dangerouslySetInnerHTML={{ __html: role?.role_description }}></div>
						</div>
					</div>
				</div>
			)}
			<hr className="mt-2 border-gray-700 border-t" />
		</div>
	);
};

export default RoleListItem;
